const accountMenuDataTest = {
    accountButton: 'account-accountButton',
    menu: {
        serviceAccountButton: 'account-menu-serviceAccount-button',
        trackerButton: 'account-menu-tracker-button',
        notificationSetupButton: 'account-menu-notificationSetup-button',
    },
    cloudShell: {
        cloudShellButtonGlobal: 'cloudShell-button-global',
    },
    serviceAccount: {
        serviceAccountCounter: 'serviceAccount-counter',
        createServiceAccount: 'serviceAccount-createServiceAccount-button',
        createServiceAccountWhenNoServiceAccounts: 'serviceAccount-noExisting-createServiceAccount-button',
    },
    tracker: {
        refresh: 'tracker-refresh-button',
        exportCsv: 'tracker-exportCsv-button',
        counter: 'tracker-counter',
        taskItem: {
            statusIcon: 'tracker-taskItem-statusIcon',
            actionName: 'tracker-taskItem-actionName',
            resourceNameOrId: 'tracker-taskItem-resourceNameOrId',
            serviceName: 'tracker-taskItem-serviceName',
            date: 'tracker-taskItem-date',
            card: 'tracker-taskItem-card',
            cardActive: 'tracker-taskItem-card-active',
        },
        taskDescription: {
            serviceName: 'tracker-taskDescription-serviceName',
            actionName: 'tracker-taskDescription-actionName',
            resourceNameOrId: 'tracker-taskDescription-resourceNameOrId',
            statusIcon: 'tracker-taskDescription-statusIcon',
            statusLabel: 'tracker-taskDescription-statusLabel',
            startTime: 'tracker-taskDescription-startTime',
            user: 'tracker-taskDescription-user',
            proxyResource: 'tracker-taskDescription-proxyResource',
            taskDuration: 'tracker-taskDescription-taskDuration',
            region: 'tracker-taskDescription-region',
            taskId: 'tracker-taskDescription-taskId',
            failureReason: 'tracker-taskDescription-failureReason',
            threeDotsMenuButton: 'tracker-taskItem-threeDotsMenu-button',
            viewApiResponseButton: 'tracker-taskItem-viewApiResponse-button',
            apiResponseCodeSnippet: 'tracker-taskItem-apiResponse-codeSnippet',
            subTask: 'tracker-taskDescription-subTask-', // add sub-task id at the end
            tags: {
              tagGroupTitle: 'tracker-taskDescription-tags-title-', // add tag group name at the end
              tagGroup: 'tracker-taskDescription-tags-group-', // add tag group name at the end
              tag: 'tracker-taskDescription-tags-', //format: tracker-taskDescription-tags-${groupName}-tag-${tagKey}
            },
        },
        filter: {
            searchForText: 'tracker-filter-searchFor-text',
            timeFrameDropdown: 'tracker-filter-timeFrame-dropdown',
            workloadsDropdown: 'tracker-filter-workloads-dropdown',
            statusesDropdown: 'tracker-filter-statuses-dropdown',
            userDropdown: 'tracker-filter-user-dropdown',
            filterItem: 'tracker-filter-filterItem',
            clearAllButton: 'tracker-filter-clearAll-button',
        }
    },
    notificationSetup: {
        sns: {
            enableSnsToggle: 'notificationSetup-sns-enableSns-toggle',
            arnInput: 'notificationSetup-sns-arn-input',
            accessPolicyInstruction: 'notificationSetup-sns-accessPolicyInstruction-text',
            sendTestNotificationButton: 'notificationSetup-sns-sendTestNotification-button',
            sendTestNotificationInlineNotification: 'notificationSetup-sns-sendTestNotification-inlineNotification',
        },
        enableBxpToggle: 'notificationSetup-enableBxp-toggle',
        documentationLink: 'notificationSetup-documentation-link',
        footer: {
            applyButton: 'notificationSetup-footer-apply-button',
            cancelButton: 'notificationSetup-footer-cancel-button',
            testNotificationInfo: 'notificationSetup-footer-testNotificationInfo-text',
        }
    }
}

export default accountMenuDataTest
